import { IAppState } from '../../../AppModulesWrapper';

export const selectCanFillBalance = (state: IAppState): boolean => {
  return state.servicePickerWidget.balance.canFill;
};
